<div class="item-container">
  <ng-container *ngIf="isLoading; else dataLoaded">
    <mat-progress-bar mode="query"></mat-progress-bar>
  </ng-container>
  <ng-template #dataLoaded>
    <ng-container *ngIf="signedDocs.length > 0">
      <h3 class="subtitle">{{ 'SignedDocuments' | translate }}</h3>
      <ng-container *ngFor="let doc of signedDocs">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: doc }"></ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="caseDocs.length > 0">
      <h3 class="subtitle">{{ 'CaseDocuments' | translate }}</h3>
      <ng-container *ngFor="let doc of caseDocs">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: doc }"></ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="signedDocs.length === 0 && caseDocs.length === 0">
      <ng-container *ngFor="let doc of bundle">
        <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: doc }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>

<ng-template #itemTemplate let-doc>
  <div class="item">
    <div class="doc-info">
      <label class="body-medium">{{ doc.name }}{{doc.read && doc.read.required ? '*' : ''}}</label>
      <p class="doc-description" *ngIf="doc.description">{{ doc.description }}</p>
    </div>
    <div class="status">
      <!-- Botão de view para documentos confidenciais -->
      <button
        *ngIf="doc.confidential"
        mat-icon-button=""
        (click)="view(doc)"
        [matTooltip]="'ViewDocument' | translate">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
        </svg>
      </button>

      <!-- Botão de download para documentos não confidenciais -->
      <button
        *ngIf="!doc.confidential"
        mat-icon-button=""
        (click)="download(doc)"
        [matTooltip]="'DownloadDocument' | translate">
        <img
          src="../../../../../../../assets/icons/icon-download.svg"
          alt=""
        />
      </button>

      <!-- Indicadores de status -->
      <ng-container *ngIf="!hideStatus">
        <img
          *ngIf="state[doc.name]"
          src="../../../../../../../assets/icons/green-check.svg"
          alt=""
        />
        <img
          *ngIf="!state[doc.name]"
          src="../../../../../../../assets/icons/grey-check.svg"
          alt=""
        />
      </ng-container>
    </div>
  </div>
</ng-template>
